export enum OrderType {
  OneOff = 'oneoff',
  ShipToday = 'shiptoday',
  New = 'new',
  Default = 'default',
}
